var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.023,
    height: 67.023,
    viewBox: "0 0 67.023 67.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26358",
    "data-name": "Group 26358",
    transform: "translate(-820.609 -529.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-info",
    "data-name": "Icon material-info",
    d: "M36.512,3A33.512,33.512,0,1,0,70.023,36.512,33.524,33.524,0,0,0,36.512,3Zm3.351,50.267h-6.7V33.16h6.7Zm0-26.809h-6.7v-6.7h6.7Z",
    transform: "translate(817.609 526.005)",
    fill: "#2c53bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAlert);
export default __webpack_public_path__ + "static/media/info-alert.562dcd79bbd47c5af2d86cdaa0e874ac.svg";
export { ForwardRef as ReactComponent };